import {Page} from '../../src/common/constant/page';
import NoticeV4 from '../../src/common/container/NoticeV4';
import {IKwPage} from '../../src/common/type';
import {routeBack} from '../../src/common/util/PageRouter';
import {sendMoreEvent} from '../../src/more/common';
import MoreContainerV4 from '../../src/more/component/MoreContainerV4';

interface IProps {
  focusId?: number;
}

interface IQuery {
  focus_id?: string;
}

const NoticePage: IKwPage<IProps, IQuery> = ({focusId}) => {
  return (
    <MoreContainerV4
      isShortHeaderGradient
      onClickHeaderButton={() => {
        sendMoreEvent({
          page: 'sidemnu_notice',
          actionName: 'back',
          customProps: {event_layer: 'header'},
        });
        routeBack();
      }}
    >
      <NoticeV4
        type="notification"
        focusId={focusId}
        onClickItem={isOpened => {
          !isOpened &&
            sendMoreEvent({
              page: 'sidemnu_notice',
              actionName: 'notice',
            });
        }}
      />
    </MoreContainerV4>
  );
};

NoticePage.initialPageProps = {
  page: Page.MoreNotice,
  getPageTitle: i18next => i18next.t('common_notice'),
};

NoticePage.getInitialProps = ({query}) => {
  const focusId = query.focus_id ? Number(query.focus_id) : undefined;

  return {
    focusId,
  };
};

export default NoticePage;
